export const interestsSettingsPage = {
  en: {
    "user.setting.interests.title": "Top 3 gift’s interests",
  },
  es: {
    "user.setting.interests.title": "Top 3 gift’s interests",
  },
};
